import { push } from 'connected-react-router';
import { connect } from 'react-redux';

import { medications } from 'src/app/router/paths';
import { loadPatient, resetNavBar, toggleHideHeader, toggleHideNavLinks } from 'src/app/state/actions';
import { loadHomescreenMedications } from 'src/app/state/actions/homescreen';
import {
  getAccountEmail,
  getCurrentUser,
  getIsFetchingBffPatient,
  getIsFetchingMedications,
  getPendingTransfers,
  getPrimaryPatient,
  getUserIsLoginSet,
} from 'src/app/state/selectors';
import type { Dispatch, RootState } from 'src/app/state/store';
import { getLocationParams } from 'src/app/utils';

import { PartnerOnboardingFlow as Renderer } from '.';

const mapStateToProps = (state: RootState) => {
  const { promo } = getLocationParams(state.router?.location?.search) as { [key: string]: string };
  /*
   Currently hardcoding to "true" because we didn't have a clear direction for the state of the feature behind this flag
   at the moment where we last revisited, on 06/24/2024. This should be revisited when we have a clear direction.
  */
  const isOnboardingFlowEnabled = true;

  return {
    currentUser: getCurrentUser(state),
    currentUserEmail: getAccountEmail(state),
    isFetchingMedications: getIsFetchingMedications(state),
    isFetchingPatient: getIsFetchingBffPatient(state),
    isLoginSet: getUserIsLoginSet(state),
    isOnboardingFlowEnabled,
    patient: getPrimaryPatient(state),
    pendingTransfers: getPendingTransfers(state),
    promo,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchFetchPatient: () => dispatch(loadPatient()),
  dispatchHideNavLinks: () => dispatch(toggleHideNavLinks()),
  dispatchLoadHomescreenMedications: () => dispatch(loadHomescreenMedications()),
  onResetNavBar: (...args) => dispatch(resetNavBar(...args)),
  onToggleHideHeader: (...args) => dispatch(toggleHideHeader(...args)),
  redirectHome: () => dispatch(push(medications.toPath())),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export const PartnerOnboardingFlow = connector(Renderer);
